module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.c3f8d68f.otf";